import UserCustomSignatureParams from "@/domain/entities/user/UserCustomSignature";
import { UserSignature as UserSignatureMailvista } from "@cs_teamwaydev/mailvista-sdk_react";

export const userSignatureToDomainMapper = (
    signature: UserSignatureMailvista,
): UserCustomSignatureParams =>
    new UserCustomSignatureParams({
        id: signature.id,
        userId: signature.userId,
        avatarURL: signature.avatar,
        name: signature.name,
        jobTitle: signature.jobTitle,
        email: signature.email,
        companyName: signature.companyName,
        phone: signature.phone,
        website: signature.website,
        other: signature.other,
        isFavorite: signature.isFavorite,
    });

export const userSignatureToMailvistaMapper = (
    signature: UserCustomSignatureParams,
): UserSignatureMailvista => ({
    id: signature.id,
    userId: signature.userId,
    isFavorite: signature.isFavorite,
    avatar: signature.avatarURL,
    name: signature.name,
    jobTitle: signature.jobTitle,
    email: signature.email,
    companyName: signature.companyName,
    phone: signature.phone,
    website: signature.website,
    other: signature.other,
});
